import "@fontsource/source-sans-pro";
import "./i18n/i18n";
import "./styles/index.css";
import AppProviders from "./components/layout/AppProviders/AppProviders";
import AppContent from "./components/layout/AppContent/AppContent";

const App = () => {
  return (
    <AppProviders>
      <AppContent />
    </AppProviders>
  );
};

export default App;
